<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <p *ngIf="data.body">{{data.body}}</p>
</div>
<!--
  Emphasis belongs on the button that carries out what was asked for, and
  the way out stays quiet. This was the other way round by accident: the
  confirm button asked for `warn`, whose default palette entry on these
  skins is a near-white A200, so the action the operator opened the dialog
  for rendered as bare text beside a solid, filled Cancel.

  The confirm keeps `cdkFocusInitial`, so Enter still does the expected
  thing; Escape and the backdrop close with undefined, which every caller
  reads as "no".
-->
<div mat-dialog-actions>
  <button mat-stroked-button (click)="onNoClick()">{{data.noButton}}</button>
  <button mat-flat-button color="primary" [mat-dialog-close]="data.returnValue" cdkFocusInitial>{{data.yesButton}}</button>
</div>
